import React from 'react';
import { Button } from '../../../components/base/Button';

const ProductsSection: React.FC = () => {
  const products = [
    {
      title: "Residential Gutters",
      subtitle: "Perfect for Most Homes",
      description: "Our most popular gutter guard solution fits standard 5\" and 6\" residential gutters. Easy to install, effective at blocking leaves while allowing water flow.",
      image: "https://static.readdy.ai/image/8f86aa673083729b29d3e3ce11202afe/961a93af6ca3e2ecc5601c1be5ff4791.jpeg",
      features: ["5\" & 6\" gutters", "Easy DIY install", "Blocks debris water flows through"],
      link: "https://www.gutterbrush.com/pages/how-to-measure-for-gutter-guards"
    },
    {
      title: "Large Commercial Gutters",
      subtitle: "Heavy-Duty Protection",
      description: "Designed for commercial buildings and larger residential properties. Available in multiple diameters to fit any gutter system from 2.25\" to 8.0\".",
      image: "https://static.readdy.ai/image/8f86aa673083729b29d3e3ce11202afe/c17b1a6fa1912dd0f09274c7f67291f3.jpeg",
      features: ["6.5\" to 8.0\" diameters", "Commercial grade", "Heavy debris protection"],
      link: "https://www.gutterbrush.com/products/commercial-gutter-guards"
    },
    {
      title: "Custom Gutter Solutions",
      subtitle: "Tailored to Your Needs",
      description: "Special sizing and configurations available for unique gutter systems. Our experts help determine the perfect fit for your specific requirements.",
      image: "https://static.readdy.ai/image/8f86aa673083729b29d3e3ce11202afe/aa0252453838e866fbfc35465859dc99.jpeg",
      features: ["Custom sizing", "Expert consultation", "Perfect fit guarantee"],
      link: "https://www.gutterbrush.com/products/5-inch-gutter-guards"
    }
  ];

  return (
    <section id="products" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          {/* GutterBrush Logo */}
          <div className="mb-8">
            <img 
              src="https://static.readdy.ai/image/8f86aa673083729b29d3e3ce11202afe/ec1806c09d9b6f31b4369acf1e154a8b.png"
              alt="GutterBrush Logo"
              className="mx-auto h-20 w-auto"
            />
          </div>
          
          <h2 className="text-4xl font-bold text-gray-800 mb-4">
            Our Gutter Protection Products
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Available in 6 diameters to protect any residential or commercial gutter system. 
            Simple, effective, and built to last.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {products.map((product, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="relative h-64">
                <img 
                  src={product.image}
                  alt={product.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <p className="text-orange-500 font-medium text-sm mb-2">{product.subtitle}</p>
                <h3 className="text-2xl font-bold text-gray-800 mb-4">{product.title}</h3>
                <p className="text-gray-600 mb-6 leading-relaxed">{product.description}</p>
                
                <ul className="space-y-2 mb-6">
                  {product.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-gray-700">
                      <i className="ri-check-line text-green-500 mr-2"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
                
                <Button variant="outline" className="w-full" href={product.link}>
                  Learn More
                </Button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Button size="lg" href="https://www.gutterbrush.com/pages/request-a-free-gutterbrush-quote" target="_blank" rel="noopener noreferrer">
            Get Custom Quote for Your Home
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;
